import { IconsMockApi } from 'app/helpers/mock-api/ui/icons/api';
import { MessagesMockApi } from 'app/helpers/mock-api/common/messages/api';
import { NavigationMockApi } from 'app/helpers/mock-api/common/navigation/api';
import { NotificationsMockApi } from 'app/helpers/mock-api/common/notifications/api';
import { SearchMockApi } from 'app/helpers/mock-api/common/search/api';
import { ShortcutsMockApi } from 'app/helpers/mock-api/common/shortcuts/api';
import { UserMockApi } from 'app/helpers/mock-api/common/user/api';

// Removed unused Fuse demo mock APIs (academy, activities, analytics, auth, chat,
// contacts, crypto, ecommerce, filemanager, finance, helpcenter, mailbox, notes,
// project, scrumboard, tasks) — these bundled ~300 kB of moment.js into production.

export const mockApiServices = [
    IconsMockApi,
    MessagesMockApi,
    NavigationMockApi,
    NotificationsMockApi,
    SearchMockApi,
    ShortcutsMockApi,
    UserMockApi,
];
